import script from "./Searchbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Searchbar.vue?vue&type=script&setup=true&lang=ts"

import "./Searchbar.vue?vue&type=style&index=0&id=3348d019&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3348d019"]])

export default __exports__